import React, { Component } from "react";
import { connect } from "react-redux";

import { toast } from "react-toastify";
import axios from "axios";
import isEmail from "validator/lib/isEmail";
import "./style.css";

const tableContainerStyle = {
  maxHeight: "200px",
  overflowY: "auto",
};
const tableStyle = {
  borderCollapse: "collapse",
  width: "100%",
};
const cellStyle = {
  padding: "5px",
  // height: "30px"
  // border: "1px solid #ccc"
};
class NoAuthUpload extends Component {
  constructor(props) {
    super(props);
    this.state = {
      uploadedFiles: [],
      email: "",
      emailError: "",
      message: "",
      subjectMsg: "",
      uploadingFile: false,
      uploadDone: false,
      uploadSuccess: false,
    };
    this.renderUploadedFiles = this.renderUploadedFiles.bind(this);
    this.handleselectedFile = this.handleselectedFile.bind(this);
    this.handleEmailChange = this.handleEmailChange.bind(this);
  }
  componentDidMount() {}

  getInboxId = () => {
    const { inboxId, location } = this.props;

    if (inboxId) return inboxId;

    const hashSource = (location && location.hash) || window.location.hash || "";
    if (!hashSource) return null;

    return hashSource.startsWith("#") ? hashSource.slice(1) : hashSource;
  };

  componentDidUpdate(prevProps, prevState) {
    if (JSON.stringify(this.state.uploadedFiles) !== JSON.stringify(prevState.uploadedFiles)) {
      this.setState({ uploadingFile: false, uploadSuccess: false });
    }
  }

  handleEmailChange = (event) => {
    const email = event.target.value;
    if (isEmail(email)) {
      this.setState({ email, emailError: "" });
    } else {
      this.setState({ email, emailError: "This looks like an incomplete email address." });
    }
  };
  handleselectedFile = (event) => {
    event.preventDefault();

    const filesArray = Array.from(event.target.files);
    const newFiles = filesArray.map((file) => {
      return { file, progress: 0, status: "", _id: "", name: file.name };
    });

    this.setState({
      uploadedFiles: newFiles,
    });
  };

  async uploadFiles() {
    const { uploadedFiles } = this.state;
    const allowedFileTypes = [
      "xlsb",
      "jpg",
      "png",
      "pptx",
      "ppt",
      "pdf",
      "zip",
      "xlsx",
      "txt",
      "bmp",
      "mp4",
      "docx",
      "xlsm",
      "csv",
      "gif",
      "jpeg",
      "xls",
      "pbix",
      "gz",
    ];
    const inboxId = this.getInboxId();

    if (!uploadedFiles?.length || !inboxId) {
      toast.error("Invalid Inbox");
      return;
    }

    this.setState({ uploadingFile: true, uploadDone: false });

    // Prepare upload promises
    const uploadPromises = uploadedFiles.map(async (fileData, index) => {
      const fileExtension = fileData.file.name.split(".").pop().toLowerCase();

      // Validate file type
      if (!allowedFileTypes.includes(fileExtension)) {
        toast.error(`File "${fileData.file.name}" is not an allowed type`);
        return { index, success: false, message: "Invalid file type" };
      }

      const data = new FormData();
      data.append("file", fileData.file);
      data.append("email", this.state.email);
      data.append("fileName", encodeURIComponent(fileData.file.name));
      data.append("uploadInboxId", inboxId);

      try {
        const response = await axios.post(`${process.env.REACT_APP_BIGHORN_SERVER}/api/files/uploadFileNoAuth`, data, {
          headers: {
            "Content-Type": fileData.file.type,
          },
          onUploadProgress: (progressEvent) => {
            const progress = Math.round((progressEvent.loaded / progressEvent.total) * 100);
            this.setState((prevState) => {
              const newUploadedFiles = [...prevState.uploadedFiles];
              newUploadedFiles[index].progress = progress;
              return { uploadedFiles: newUploadedFiles };
            });
          },
        });

        return { index, success: response.data.success, message: response.data.message };
      } catch (error) {
        return { index, success: false, message: error.message };
      }
    });

    // Wait for all uploads to complete
    const results = await Promise.all(uploadPromises);

    // Update state with results
    this.setState((prevState) => {
      const newUploadedFiles = [...prevState.uploadedFiles];
      results.forEach(({ index, success }) => {
        newUploadedFiles[index].success = success;
      });
      return { uploadedFiles: newUploadedFiles, uploadingFile: false, uploadDone: true };
    });

    // Check if all uploads were successful
    const allSuccessful = results.every((result) => result.success);

    if (allSuccessful) {
      // Send email notification
      try {
        await axios.post(`${process.env.REACT_APP_BIGHORN_SERVER}/api/files/emailUsersNoAuth`, {
          email: this.state.email,
          fileNames: uploadedFiles.map((f) => f.name),
          uploadInboxId: inboxId,
        });
        toast.success("File(s) Uploaded");
        this.setState({ uploadSuccess: true });
      } catch (error) {
        toast.error("Error sending email notification");
      }
    } else {
      // Display errors for failed uploads
      results.forEach(({ success, message }) => {
        if (!success) {
          toast.error(message || "Error uploading file");
        }
      });
    }
  }

  renderUploadedFiles() {
    return this.state.uploadedFiles.map((item, idx) => {
      return (
        <tr key={`${item.name}-${idx}`}>
          <td style={cellStyle}>{item.name}</td>
          {/* <td style={cellStyle}>{item.progress}</td> */}
          <td className="progress-cell" style={cellStyle}>
            <div className="progress-container">
              <div className="progress-filler" style={{ width: `${item.progress}%` }}></div>
            </div>
            <span className="progress-text">{`${item.progress}%`}</span>
          </td>
        </tr>
      );
    });
  }
  render() {
    if (this.props.error !== null) {
      return (
        <div style={{ display: "flex", justifyContent: "center", marginTop: "50px" }}>
          <div>This upload inbox does not exist.</div>
        </div>
      );
    } else {
      return (
        <div className="no-auth-upload">
          <div style={{ fontSize: "24px", color: "#707070", fontWeight: 500, marginBottom: "10px" }}>
            TABS Analytics File Upload Service
          </div>

          <div>Your Email Address</div>
          <input
            style={{ width: "400px", marginTop: "10px" }}
            value={this.state.email}
            onChange={this.handleEmailChange}></input>
          {this.state.emailError && <div style={{ color: "red" }}>{this.state.emailError}</div>}
          <div className="" style={{ fontWeight: 500, marginTop: "20px" }}>
            Upload Files
          </div>
          <div style={{ fontStyle: "italic", color: "#707070", marginBottom: "10px" }}>
            Select one or more files and click Upload to send your files to TABS Analytics
          </div>
          <div>
            <input
              //hidden={true}
              id="files"
              type="file"
              name="Upload"
              multiple
              onChange={this.handleselectedFile}
              onClick={(event) => {
                event.target.value = null;
              }}
            />
            <div style={{ fontSize: "12px", marginTop: "8px", fontStyle: "italic" }}>
              Allowed file types: xlsx, xls, xlsm, xlsb, pdf, docx, pptx, ppt, csv, png, jpg, gif, bmp, txt, mp4, zip, gz, pbix
            </div>

            <div style={tableContainerStyle}>
              <table style={tableStyle}>
                <thead>
                  <tr>
                    <th style={cellStyle}>Filename</th>
                    <th style={cellStyle}>Upload %</th>
                  </tr>
                </thead>
                <tbody>{this.renderUploadedFiles()}</tbody>
              </table>
            </div>
            <div
              style={{
                cursor:
                  this.state.emailError ||
                  this.state.email === "" ||
                  this.state.uploadedFiles.length === 0 ||
                  this.state.uploadingFile
                    ? "not-allowed"
                    : "pointer",
              }}>
              <div
                onClick={() => {
                  if (!this.state.emailError && this.state.email !== "" && this.state.uploadedFiles.length > 0) {
                    this.uploadFiles();
                  }
                }}
                className={`ta-button ta-button-primary ${
                  this.state.emailError ||
                  this.state.email === "" ||
                  this.state.uploadedFiles.length === 0 ||
                  this.state.uploadingFile
                    ? "disabled"
                    : ""
                }`}
                style={{
                  height: "26px",
                  width: "72px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  pointerEvents:
                    this.state.emailError ||
                    this.state.email === "" ||
                    this.state.uploadedFiles.length === 0 ||
                    this.state.uploadingFile
                      ? "none"
                      : "auto",
                }}>
                Upload
              </div>
            </div>
            {this.state.uploadSuccess && (
              <div style={{ fontSize: "18px", fontWeight: 500, marginTop: "20px", color: "#07bc0c" }}>
                Your upload completed successfully, you can close this window.
              </div>
            )}
          </div>
        </div>
      );
    }
  }
}

const mapStateToProps = (state) => ({
  inboxId: state.app.inboxId,
  error: state.app.error,
  // reportSubLoading: state.rptSubscriptions.loading
});

const mapDispatchToProps = (dispatch) => ({
  // addTabToNav(tab) {
  //   dispatch(addTabToNav(tab));
  // },
  // getReportSubscriptions(loading, user) {
  //   dispatch(getReportSubscriptions(loading, null, user));
  // },
  // deleteReportSubscription(rptSubId, user) {
  //   dispatch(deleteReportSubscription(rptSubId, null, user));
  // },
  // selectAllSubscriptions(selectAll) {
  //   dispatch(selectAllSubscriptions(selectAll));
  // }
});

export default connect(mapStateToProps, mapDispatchToProps)(NoAuthUpload);
